import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useTheme} from 'react-jss';
import Button from '../../../../UI/Button/Button';
import {stepToPage} from '../../../actions/uiActions';
import Translation from '../../../lang/Translation';
import useStyles from './ProgressBarStep.styles';
import progressBarMapStateToProps from '../ProgressBarMapStateToProps';

export function ProgressBarStep(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const stepLabel = `${Translation.getText('step', [props.number])} ${Translation.getText(props.label)}`;
  const getLabel = props.active
    ? `${stepLabel}, ${Translation.getText('current')}`
    : `${Translation.getText('go.to', stepLabel)}`;
  
  return (
    <Button
      className={`${classes.progressStep} ProgressBarStep--${props.name}`}
      id={`ProgressBarStep-${props.number}`}
      onClick={() => props.stepToPage(props.number)}
      link
      horizontalAlign
      ariaLabel={getLabel}
      aria-current={props.active && 'step'}
    >
      <p className={classes.label}><Translation>{props.label}</Translation></p>
    </Button>
  );
}

ProgressBarStep.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  stepToPage: PropTypes.func.isRequired,
  isUsingArtemisStyles: PropTypes.bool,
  
  // Style props
  active: PropTypes.bool.isRequired,
  complete: PropTypes.bool.isRequired,
};

export default connect(progressBarMapStateToProps, {stepToPage})(ProgressBarStep);
